export default "/images/191516aece4fdf6866a905cee2a65760.avif";